import api from '../store/axiosConfig';
import { store } from '../store/store';

const MAX_FREE_FLASHCARDS = 10;

interface CreateFlashcardData {
  question: string;
  options: string[];
  correctAnswer: number;
}

// Helper function for validating flashcard limits
async function validateFlashcardLimit(collectionId: string) {
  const state = store.getState();
  const user = state.auth.user;

  // ✅ Use `api` instead of raw axios
  const response = await api.get(`/collections/${collectionId}`); // Added /api prefix
  const collection = response.data;

  if (!user?.isPremium && collection.flashcardCount >= MAX_FREE_FLASHCARDS) {
    throw new Error(
      `Free users can only create up to ${MAX_FREE_FLASHCARDS} flashcards per collection. Upgrade to premium for unlimited flashcards!`
    );
  }

  return collection;
}

export const flashcardsService = {
  async getFlashcards(collectionId: string) {
    try {
      const response = await api.get(`/flashcards/${collectionId}/flashcards`); // Added /api prefix
      return response.data;
    } catch (error) {
      console.error('Error fetching flashcards:', error);
      throw error;
    }
  },

  async getFlashcard(id: string) {
    try {
      const response = await api.get(`/flashcards/${id}`); // Added /api prefix
      return response.data;
    } catch (error) {
      console.error('Error fetching flashcard:', error);
      throw error;
    }
  },

  async createFlashcard(collectionId: string, data: CreateFlashcardData) {
    try {
      await validateFlashcardLimit(collectionId);

      const response = await api.post(`/flashcards/${collectionId}/flashcards`, data); // Added /api prefix
      return response.data;
    } catch (error) {
      console.error('Error creating flashcard:', error);
      throw error;
    }
  },

  async updateFlashcard(id: string, data: Partial<CreateFlashcardData>) {
    try {
      const response = await api.put(`/flashcards/${id}`, data); // Added /api prefix
      return response.data;
    } catch (error) {
      console.error('Error updating flashcard:', error);
      throw error;
    }
  },

  async deleteFlashcard(id: string) {
    try {
      const response = await api.delete(`/flashcards/${id}`); // Added /api prefix
      return response.data;
    } catch (error) {
      console.error('Error deleting flashcard:', error);
      throw error;
    }
  }
};
